import React from 'react';
import { Route, Switch } from 'react-router-dom';
import FormMoneyTransferRequest from './FormMoneyTransferRequest.jsx';
import ListMoneyTransferRequest from './ListMoneyTransferRequest.jsx';

const MoneyTransferRequest = ({ match }) => {
  return (
    <Switch>
      <Route
        exact={true}
        path={`${match.url}/`}
        component={ListMoneyTransferRequest}
      />
      <Route
        exact={true}
        path={`${match.url}/add`}
        component={FormMoneyTransferRequest}
      />
    </Switch>
  );
};

export default MoneyTransferRequest;
